import {
    useBxpWebStargateClient,
    GetCcpHamsStatus,
    GetCcpHamsResponse
} from "@/libraries/bxp-web-stargate-client/src/index";

import { AsyncResult, useAsync } from "./use-async";

export function useCcpHamsStatus({
    cloudId,
    offeringKeys
}: GetCcpHamsStatus): AsyncResult<GetCcpHamsResponse | null> {
    const stargateClient = useBxpWebStargateClient();

    return useAsync(
        () =>
            stargateClient.getCcpHamsStatus({
                cloudId,
                offeringKeys
            }),
        []
    );
}
